import { render, staticRenderFns } from "./LogoDesktop.vue?vue&type=template&id=5cde4f7f&scoped=true&"
import script from "./LogoDesktop.vue?vue&type=script&lang=js&"
export * from "./LogoDesktop.vue?vue&type=script&lang=js&"
import style0 from "./LogoDesktop.vue?vue&type=style&index=0&id=5cde4f7f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde4f7f",
  null
  
)

export default component.exports